import 'materialize-css';
import './modules/materialize';

// image effects
import './modules/image-effects/split-image-hover';
import './modules/image-effects/square-fracture-hover';

// text effects
import './modules/text-effects/appearing-text';
